import { Component, ViewChild, AfterViewInit } from "@angular/core";
import { Router } from "@angular/router";
import { RequestFilter, DataTablesQuery } from "@models/common";
import { RequestListResponse, RequestListItem } from "@models/requests";
import { DataTable } from "primeng/primeng";
import { DataTablePaginator } from "../../common/datatable-paginator/datatable-paginator.component";
import { RequestService } from "../request.service";

declare var jQuery: any;

@Component({
    templateUrl: "./request-list.component.html"
})

export class RequestListComponent implements AfterViewInit {
    public filter: RequestFilter;
    public editableFilter: RequestFilter = new RequestFilter();;
    public rowCount = 10;
    public editableRowCount = 10;
    public totalCount: number;
    public records: RequestListItem[];
    @ViewChild("DT") dt: DataTable;
    @ViewChild("dtp") dtp: DataTablePaginator;
    @ViewChild("typeEle") typeEle;
    public typeSelectize: any;
    constructor(private requestService: RequestService, private router: Router) { }

    ngAfterViewInit(): void {
        this.typeSelectize = jQuery(this.typeEle.nativeElement).selectize({
            options: [
                { id: 1, text: "Addition" },
                { id: 2, text: "Edit" },
                { id: 3, text: "Removal" }
            ],
            valueField: "id",
            highlight: false,
            onChange: (id) => {
                id = +id;
                if (id === 0) {
                    id = undefined;
                }
                this.editableFilter.type = id;
            }
        });
    }

    clear(): void {
        this.editableFilter = new RequestFilter();
        this.typeSelectize[0].selectize.clear();
        this.apply();
    }

    apply(): void {
        this.filter = this.editableFilter;
        this.dt.reset();
    }

    fetchRequests(event): void {
        let request = new DataTablesQuery();
        request.first = event.first;
        request.rows = event.rows;
        request.sortField = event.sortField;
        request.sortOrder = event.sortOrder;
        request.filters = this.filter;
        this.requestService.filterRequestList(request).subscribe(
            response => {
                this.totalCount = response.totalCount;
                this.records = response.data;
            }
        );
    }

    updateRows(): void {
        this.rowCount = +this.editableRowCount;
        setTimeout(() => this.dtp.updateRows());
    }
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/app/requests/request-list/request-list.component.ts